module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Here's How You Can Help!")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('router-link', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "to": "/#donate"
    }
  }, [_vm._v("Donate Now")])], 1), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cta"
  }, [_c('div', {
    staticClass: "module"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("assets/images/PFK_Icon_DonateHand.svg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Your Donation")])]), _vm._v(" "), _c('div', {
    staticClass: "module"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("assets/images/PFK_Icon_Backpack.svg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Gives backpacks with school supplies & uniforms")])]), _vm._v(" "), _c('div', {
    staticClass: "module"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("assets/images/PFK_Icon_GraduationCap.svg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Supports education for kids in developing countries")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "holiday-drive text-center"
  }, [_c('form', {
    attrs: {
      "action": "https://www.paypal.com/donate",
      "method": "post",
      "target": "_top"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "cmd",
      "value": "_s-xclick"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "hosted_button_id",
      "value": "VW2B4TRYSU2VC"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit",
      "value": "PFK’s Holiday Backpack Drive",
      "name": "submit",
      "alt": "PayPal - The safer, easier way to pay online!"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "border": "0",
      "src": "https://www.paypalobjects.com/en_US/i/scr/pixel.gif",
      "width": "1",
      "height": "1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11bf14d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/HowToHelp.vue
// module id = 305
// module chunks = 1